export const DSN = 'https://f6e597d8119649daad4e694940f990d7@sentry.io/1420535';
